import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import ImportModule from '../../components/Settings/ImportModule';
import AuditLogModule from '../../components/Settings/AuditLogModule';
import AuditLogSearch from '../../components/Settings/AuditLogSearch';
import TwoFactorAuthModule from '../../components/Settings/TwoFactorAuthModule';
import IdleTimeoutModule from '../../components/Settings/IdleTimeoutModule';
import { useAuth } from '../../context/AuthContext';

const Settings = () => {
  const { user } = useAuth();
  const canAccess = user?.role === 'admin' || user?.role === 'team_lead';
  const [showAuditLog, setShowAuditLog] = useState(false);

  if (showAuditLog) {
    return <AuditLogSearch onBack={() => setShowAuditLog(false)} />;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        {canAccess && (
          <>
            <Grid item xs={12} md={6}>
              <ImportModule />
            </Grid>
            <Grid item xs={12} md={6}>
              <AuditLogModule onViewLogs={() => setShowAuditLog(true)} />
            </Grid>
          </>
        )}
        {user?.role === 'admin' && (
          <>
            <Grid item xs={12} md={6}>
              <TwoFactorAuthModule />
            </Grid>
            <Grid item xs={12} md={6}>
              <IdleTimeoutModule />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default Settings;
